import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { DescricaoCorFundoContainerService } from './descricao-cor-fundo-container.service';
import { DescricaoCorFundoData } from '@fcp/lib-ui';

@Component({
  selector: 'fcp-descricao-cor-fundo-container',
  template: `
    <fcp-descricao-cor-fundo
      [descricaoCorFundo]="data | async"
    ></fcp-descricao-cor-fundo>
  `
})
export class DescricaoCorFundoContainerComponent implements OnInit {
  @Input() public id: string;
  public data: Observable<DescricaoCorFundoData>;
  constructor(private descricaoCorFundoContainerService: DescricaoCorFundoContainerService) {}

  ngOnInit() {
    this.data = this.descricaoCorFundoContainerService.getDescricaoCorFundo(this.id);
  }
}
